const PageTitle = ({
  title,
}) => {
  return <div className="page-title-head d-flex align-items-center gap-2">
      <div className="flex-grow-1">
        <h4 className="fs-18 fw-bold mb-0">{title}</h4>
      </div>
    </div>;
};
export default PageTitle;